import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isArray from 'lodash/isArray';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useMediaQuery, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '../../src/i18n';
import { useFBTableStyles } from '.';

const SimpleTable = ({ headers, data, cells, customElements, tableClassName, headClassName }) => {
  const { classes, cx } = useFBTableStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));

  const getValueFromArray = (item, array) => {
    for (let i = 0; i < array.length; i++) {
      const value = get(item, array[i]);
      if (value) return value;
    }
    return null;
  };
  const customRow = mobileView
    ? customElements
      ? customElements.card
      : null
    : customElements
    ? customElements.row
    : null;

  if (data?.length === 0) {
    return <span className={classes.empty}>{t('operabase.general.NO_RESULTS')}</span>;
  }

  return (
    <>
      {mobileView ? (
        <Grid container spacing={2}>
          {data.map((card, index) => (
            <Grid key={get(data, 'id')} item sm={12} xs={12}>
              {React.cloneElement(customRow, {
                data: card,
                key: get(data, 'id') || index,
              })}
            </Grid>
          ))}
        </Grid>
      ) : (
        <div className={cx(classes.table, tableClassName)}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map(item => (
                  <TableCell
                    classes={{ head: cx(headClassName, classes.head) }}
                    key={get(item, 'props.id') || item}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) =>
                customRow ? (
                  React.cloneElement(customRow, {
                    data: row,
                    key: get(row, 'id') || index,
                  })
                ) : (
                  <TableRow key={get(row, 'id') || index}>
                    {cells.map(item => (
                      <TableCell className={classes.cell} key={get(row, item) || get(row, `[0].${item}`)}>
                        {isArray(item) ? getValueFromArray(row, item) : get(row, item, '')}
                      </TableCell>
                    ))}
                  </TableRow>
                ),
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </>
  );
};

SimpleTable.propTypes = {
  data: PropTypes.array,
  headers: PropTypes.array,
  cells: PropTypes.array,
  customElements: PropTypes.shape({
    card: PropTypes.element,
    row: PropTypes.element,
  }),
};

SimpleTable.defaultProps = {
  data: [],
  headers: [],
};

export default SimpleTable;
